export const formatRange = ({
	data,
	formatter,
	withSpaces = true,
}: {
	data?: number[];
	formatter?: (value: number) => string;
	withSpaces?: boolean;
}): string => {
	if (!data?.length) return "";
	const min = Math.min(...data);
	const max = Math.max(...data);
	if (min === max) return formatter ? formatter(min) : min.toString();
	const minFormatted = formatter ? formatter(min) : min.toString();
	const maxFormatted = formatter ? formatter(max) : max.toString();
	if (minFormatted === maxFormatted) return minFormatted;
	return `${minFormatted}${withSpaces ? " - " : "-"}${maxFormatted}`;
};
